export default __webpack_public_path__ + "images/a917bf209fefe09069245ab35a3bdc1a-validointilogo.png";